module.exports = __webpack_public_path__ + "img/Weapon_174.c0234869.png";